module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/GA-d3599d325f93422a06aff684ad571001.png";